<template>
  <section class="page-patient-form">
    <Breadcrumbs :items="breadcrumbs" />

    <div class="content">
      <rp-patient-form
        @submit="addPatient"
        :genders="genders"
        :locales="locales"
        :engagementTypes="engagementTypes"
        v-model="form"
      />

      <terms />
      <rp-overlay :active="active">
        <rp-alert
          icon="done"
          :message="successMessage"
          :onClick="successFunction"
        >
        </rp-alert>
      </rp-overlay>
    </div>
  </section>
</template>

<script>
import PatientForm from "raypro_ui/src/components/ui/forms/Patient";
import { createPatient } from "raypro_ui/src/api/users";
import { getLocales } from "raypro_ui/src/api/locales";
import { getEngagementTypes } from "raypro_ui/src/api/engagement_types";
import Terms from "@/components/Terms";
import Breadcrumbs from "@/components/Breadcrumbs";
import Overlay from "raypro_ui/src/components/ui/Overlay";
import Alert from "raypro_ui/src/components/ui/Alert";
import page from "@/mixins/page";

export default {
  data() {
    return {
      errors: {},
      form: {},
      genders: [
        { label: "Male", value: "M" },
        { label: "Female", value: "F" },
        { label: "Prefer not to say", value: "O" }
      ],
      locales: [],
      engagementTypes: [],
      active: false,
      successMessage: "Patient added successfully!",
      breadcrumbs: [{ label: "Add Patient" }],
      title: "Add Patient"
    };
  },

  mixins: [page],

  computed: {
    userPayload() {
      const form = this.form;

      return {
        patient: {
          email: form.email,
          locale_id: form.locale,
          patient_id: form.patient_id,
          created_by: this.$store.getters.authUser.id,
          profile: {
            first_name: form.first_name,
            last_name: form.last_name,
            gender: form.gender,
            yob: form.yob,
            phone: form.phone,
            engagement_type_id: form.engagement_type_id
          }
        }
      };
    }
  },

  components: {
    "rp-patient-form": PatientForm,
    "rp-overlay": Overlay,
    "rp-alert": Alert,
    Terms,
    Breadcrumbs
  },

  mounted() {
    this.getLocales();
    this.getEngagementTypes();
  },

  methods: {
    successFunction() {
      this.$router.go();
    },

    addPatient() {
      createPatient(this.userPayload)
        .then(() => {
          const patientEmail = this.userPayload.patient.email;

          this.$router.push({
            name: "add-operation",
            params: { patientEmail: patientEmail }
          });
          this.active = true;
        })
        .catch(({ response }) => {
          // TODO: map errors to flat structure for form
          this.errors = response.errors;
        });
    },

    getLocales() {
      getLocales()
        .then(({ data }) => {
          this.locales = data;
        })
        .catch(() => {
          alert("Cannot get locales");
        });
    },

    getEngagementTypes() {
      getEngagementTypes()
        .then(({ data }) => {
          this.engagementTypes = data;
        })
        .catch(() => {
          alert("Cannot get engagement types");
        });
    }
  }
};
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/components/pages/Patients/AddPatient.vue